import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetActiveProjectsForAPIKeyManagementRPC } from "./getActiveProjectsForApiKeyManagementRPC";

export class GetActiveProjectsForAPIKeyManagementRPCClientImpl extends GetActiveProjectsForAPIKeyManagementRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetActiveProjectsForAPIKeyManagementRPC.Request): Promise<LeoRPCResult<GetActiveProjectsForAPIKeyManagementRPC.Response, GetActiveProjectsForAPIKeyManagementRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "external-public-apis/GetActiveProjectsForAPIKeyManagement",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetActiveProjectsForAPIKeyManagementRPC.ResponseDTO,
      GetActiveProjectsForAPIKeyManagementRPC.Errors.ErrorsDTO,
      GetActiveProjectsForAPIKeyManagementRPC.Response,
      GetActiveProjectsForAPIKeyManagementRPC.Errors.Errors
    >(
      response,
      "external-public-apis/GetActiveProjectsForAPIKeyManagement",
      GetActiveProjectsForAPIKeyManagementRPC.Response.fromDTO,
      GetActiveProjectsForAPIKeyManagementRPC.Errors.fromDTO
    );
  }
}
